export default "__VITE_ASSET__pWn6WWtd__"